<template>
  <div class="query-auth-history">
    <query-form :config="['串号', '操作类型', '创建时间', '产品名称', '生产者账号']" @fetch-data="fetchData"></query-form>

    <count-total :total="total"></count-total>

    <my-list :dataSource="dataSource" :loading="loading" :flag="flag" :search="search"></my-list>
  </div>
</template>

<script>
import { queryHistoryNote } from '../../api/api'

export default {
  name: 'query-auth-history',

  data() {
    return {
      dataSource: [],
      loading: false,
      total: 0,
      flag: true, // 修改初始值为false，防止页面一加载就触发滚动加载
      search: {
        productID: '',
        producerUsername: '',
        serialNumber: '',
        recordType: '',
        stime: -28800000,
        etime: 11587891746587,
        current: 1,
        size: 10
      }
    }
  },

  methods: {
    fetchData(params) {

      if (params && params.isQuery) {
        this.dataSource = []
        // 对于查询操作，重置为第一页
        params.current = 1
      }

      const para = {
        keys: {
          productID: params ? params.productID || '' : '',
          producerUsername: params ? params.producerUsername || '' : '',
          serialNumber: params ? params.serialNumber || '' : '',
          recordType: params ? params.recordType || '' : '',
          stime: params ? params.stime || -28800000 : -28800000,
          etime: params ? params.etime || 11587891746587 : 11587891746587
        },
        page: {
          size: params.size,
          current: params.current
        }
      }
      this.search = params
      this.loading = true
      queryHistoryNote(para).then(res => {
        if (res.error.code === 0) {
          this.total = res.response.total
          // 使用total来判断是否还有更多数据，防止死循环
          this.flag = params.current * params.size < this.total;
          this.dataSource = this.dataSource.concat(res.response.records)
          this.loading = false
        } else {
          this.dataSource = []
          this.loading = false
        }
      })
    }
  }
}
</script>